module.exports = __webpack_public_path__ + "img/bedroom.c9117a3e.svg";